<div *ngIf="headerEnabled" class="container py-4 border-bottom border-muted">
  <div class="row">
    <div class="col-4 col-sm-3">
      <a href="#" (click)="back($event)" *ngIf="backButtonEnabled" class="fw-light mb-0 link-body text-decoration-none">
        <i class="fa-solid fa-chevron-left"></i> {{ 'cart_header.back_btn' | translate }}
      </a>
    </div>

    <div class="col-8 col-sm-9 text-end" *ngIf="ticketCount !== undefined">
      <p *ngIf="ticketCount !== undefined && ticketCount <= 0" class="fw-light mb-0">
        {{ 'cart_header.cart_fill_states.empty' | translate }} <i class="fa-solid fa-cart-shopping"></i>
      </p>

      <a *ngIf="ticketCount > 0 && nextButtonEnabled" href="#" class="text-body  fw-light mb-0 text-decoration-none" (click)="gotToCart($event)">
        <span *ngIf="ticketCount > 1">
          {{ 'cart_header.cart_fill_states.multiple' | translate: {count: ticketCount} }}
        </span>
        <span *ngIf="ticketCount === 1">
          {{ 'cart_header.cart_fill_states.single' | translate: {count: ticketCount} }}
        </span>
        <i class="fa-solid fa-cart-shopping"></i>
      </a>
    </div>

    <div *ngIf="(ticketCount?? 0) > 0 && nextButtonEnabled" class="col-12 pt-3 text-end">
      <button (click)="gotToCart($event)" type="button" class="btn btn-lg btn-primary">{{ 'cart_header.summary_btn' | translate }}</button>
    </div>
  </div>
</div>
